export var filtersRow_dropdown_allBusinessUnits = {
    key: 'dashboard::filtersRow_dropdown_allBusinessUnits',
    fallback: "All Business Units"
};
export var filtersRow_dropdown_allCountries = {
    key: 'dashboard::filtersRow_dropdown_allCountries',
    fallback: "All Countries"
};
export var filtersRow_toggle_amount = {
    key: 'dashboard::filtersRow_toggle_amount',
    fallback: "Amount"
};
export var filtersRow_toggle_payments = {
    key: 'dashboard::filtersRow_toggle_payments',
    fallback: "Transactions"
};
export var flow_desc_blocked = {
    key: 'dashboard::flow_desc_blocked',
    fallback: "Transactions blocked by PaymentsOS's Decision Engine"
};
export var flow_desc_declined = {
    key: 'dashboard::flow_desc_declined',
    fallback: "Transactions declined by your processors"
};
export var flow_desc_initiated = {
    key: 'dashboard::flow_desc_initiated',
    fallback: "Payments initiated in PaymentsOS"
};
export var flow_desc_refund = {
    key: 'dashboard::flow_desc_refund',
    fallback: "Transactions successfully refunded to your customers"
};
export var flow_desc_successful = {
    key: 'dashboard::flow_desc_successful',
    fallback: "Transactions that have been successfully charged"
};
export var flow_desc_voided = {
    key: 'dashboard::flow_desc_voided',
    fallback: "Transactions that have been cancelled before execution"
};
export var flow_lbl_blocked = {
    key: 'dashboard::flow_lbl_blocked',
    fallback: "Blocked"
};
export var flow_lbl_declined = {
    key: 'dashboard::flow_lbl_declined',
    fallback: "Declined"
};
export var flow_lbl_initiated = {
    key: 'dashboard::flow_lbl_initiated',
    fallback: "Initiated"
};
export var flow_lbl_refund = {
    key: 'dashboard::flow_lbl_refund',
    fallback: "Refund"
};
export var flow_lbl_successful = {
    key: 'dashboard::flow_lbl_successful',
    fallback: "Successful"
};
export var flow_lbl_voided = {
    key: 'dashboard::flow_lbl_voided',
    fallback: "Voided"
};
export var tabs_lbl_currency = {
    key: 'dashboard::tabs_lbl_currency',
    fallback: "Currency"
};
export var tabs_lbl_paymentMethod = {
    key: 'dashboard::tabs_lbl_paymentMethod',
    fallback: "Payment Method"
};
export var tabs_lbl_provider = {
    key: 'dashboard::tabs_lbl_provider',
    fallback: "Provider"
};
export var tabs_text_empty = {
    key: 'dashboard::tabs_text_empty',
    fallback: "There are no transactions in the selected time period"
};
